import React, { memo, useEffect, useRef } from 'react';
import { customGaEvent, GA_EVENTS } from 'utils/ga';
import { useIframeEngageListener } from 'hooks';

import './EmbeddedForm.scss';
import IframeForm from "./IframeForm";
import SlateForm from "./SlateForm";
import { embeddedFormTypes } from "./embeddedFormConstants";

const EmbeddedForm = ({
  name,
  description,
  defaultMsg,
  showDefault,
  formEmbedCode,
  type,
  publicTour,
  classes,
}) => {
  const formIframeRef = useRef(null);

  useIframeEngageListener({
    attachListener: publicTour,
    onEngage: () =>
      customGaEvent({
        action: GA_EVENTS.FORM_ENGAGE,
        label: name,
      }),
  });

  useEffect(() => {
    if (formIframeRef.current && formEmbedCode) {
      const iframeDocument = formIframeRef.current.contentDocument || formIframeRef.current.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(formEmbedCode);
      iframeDocument.close();
    }
  }, [formEmbedCode]);

  const renderForm = () => {
    if (type === embeddedFormTypes.SLATE) {
      return (
        <SlateForm formEmbedCode={formEmbedCode} />
      );
    }

    return (
      <IframeForm formEmbedCode={formEmbedCode} />
    )
  }

  return (
    <div id="embedded-form" className={classes}>
      {showDefault ? (
        <p>{defaultMsg}</p>
      ) : (
        <section id="embedded-form-content">
          <h1 id='form-title' className="tour-editor-forms-container__right__name">{name}</h1>
          <p className="tour-editor-forms-container__right__description">
            {description}
          </p>

          { renderForm() }
        </section>
      )}
    </div>
  );
};

export default memo(EmbeddedForm);
